export default {
  topWelcome: "📚 Welcome to the largest language learning collection",

  topDescription:
    "With engaging and entertaining methods, we make language learning more enjoyable for children. ✨",

  languageFa: "FA",
  languageEn: "EN",

  loginRegister: "Login / Register",
  phoneNumber: "0912-698-5171",

  cartPrice: "Tomans",

  home: "Home",
  bookCategories: "Categories",
  aboutUs: "About Us",
  contactUs: "Contact Us",

  rulesAndRegulations: "Terms & Conditions",
  FAQ: "FAQ",
  shippingMethod: "Shipping Methods",
  returnProduct: "Returns",
  mobileNumber: "Mobile Number",
  orderList: "Order List",
  logout: "Log Out",
  logoAlt: "logo",
  titleMenuInMobile: "Menu",
  urls: {
    Main: "/en",
    AboutUs: "/about-us",
    Contact: "/contact",
    Cart: "cart",
    FAQ: "/FAQ",
    ProductCategory: "/en/product-category",
    Order:"/en/dashboard/Order",
    Profile:"/en/dashboard/profile",
  }
};
